<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue?: any
  multiple?: boolean
  mandatory?: boolean
  divided?: boolean
  density?: 'default' | 'comfortable' | 'compact'
  variant?: 'flat' | 'outlined' | 'tonal' | 'text'
  color?: string
  rounded?: boolean
}>(), {
  variant: 'outlined',
  density: 'default',
})

const emit = defineEmits<{
  'update:modelValue': [val: any]
}>()

provide('m-btn-toggle-value', computed(() => props.modelValue))
provide('m-btn-toggle-select', (val: any) => {
  if (props.multiple) {
    const current = Array.isArray(props.modelValue) ? [...props.modelValue] : []
    const idx = current.indexOf(val)
    if (idx >= 0) {
      if (!props.mandatory || current.length > 1) current.splice(idx, 1)
    } else {
      current.push(val)
    }
    emit('update:modelValue', current)
  } else {
    if (props.modelValue === val && !props.mandatory) {
      emit('update:modelValue', undefined)
    } else {
      emit('update:modelValue', val)
    }
  }
})
</script>

<template>
  <div
    class="m-btn-toggle"
    :class="[
      `m-btn-toggle--${variant}`,
      { 'm-btn-toggle--divided': divided, 'm-btn-toggle--rounded': rounded }
    ]"
    role="group"
  >
    <slot />
  </div>
</template>

<style scoped>
.m-btn-toggle {
  display: inline-flex;
  border-radius: var(--m-radius);
  overflow: hidden;
}

.m-btn-toggle--outlined { border: 1px solid var(--m-border); }
.m-btn-toggle--rounded { border-radius: var(--m-radius); }

.m-btn-toggle--divided > :deep(*:not(:last-child)) {
  border-right: 1px solid var(--m-border);
}
</style>
